import React, {useState, useEffect} from 'react'
// Styles
import './success.style.css'
// Images
import IconSuccess from '../../assets/images/icons/success.png'
// Component
import Copyright from '../../components/Copyright'
// Constant
import { Base_API } from '../../_actions/matcher'
import { useParams } from 'react-router-dom'

function ReceiveSVBranch_Success(props) {

    // handle submit
    const handleSubmit = () => {
        // Close Window Line
        window.location.href = Base_API.sharing_lineoa;
    }

    return (
        <div className='succ-container t-blue'>
            {/* header text */}
            <h1 className="header-text">ทำนัดหมายสำเร็จ</h1>
            {/* icons success */}
            <img className="icon-succ" src={IconSuccess} />
            {/* desc */}
            <p className="desc t-black">ขอบคุณที่ใช้บริการ N Health</p>
            {/* space */}
            <div className="space"></div>
            {/* submit btn */}
            <div className="btn-submit-wrap">
                <button 
                    className="btn-submit t-white"
                    onClick={handleSubmit}
                >
                    ปิดหน้านี้
                </button>
            </div>

            <Copyright position={'fixed'} bgColor={'#F9FBFF'} />
        </div>
    )
}

export default ReceiveSVBranch_Success;